/** @jsxImportSource @emotion/react */
import { useReferenceService } from "../services/useRulesSetService";
import Loader from "../components/MainComponents/Loader/Loader";
import ReactMarkdown from "react-markdown";
import { css, useTheme } from "@emotion/react";
import ReferenceCard from "components/MainComponents/Reference/ReferenceFrame/ReferenceCard";

export default function ReferencesFrame() {
  const { referenceData, loading, error } = useReferenceService();
  const theme = useTheme();
  const linkItem = css`
    font-family: ${theme.typography.bodyMedium.fontFamily};
    font-size: ${theme.typography.bodyMedium.fontSize};
    font-weight: ${theme.typography.bodyMedium.fontWeight};
    color: ${theme.colors.textDark};
    display: flex;
    align-items: center;
    margin-bottom: ${theme.spacing.md};

    a {
      text-decoration: underline;
      color: ${theme.colors.textDark};
      font-weight: ${theme.typography.body_semiBold.fontWeight};
    }

    span {
      margin-left: ${theme.spacing.sm};
      background-color: ${theme.colors.primary};
      color: ${theme.colors.white};
      font-size: 12px;
      font-weight: ${theme.typography.body_semiBold.fontWeight};
      padding: 4px 8px;
      border-radius: 5px;
    }
  `;

  const referencesContainer = css`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${theme.spacing.xxxl};
    margin-top: ${theme.spacing["5xl"]};
  `;

  const pageTitle = css`
    font-family: ${theme.typography.heading2_semiBold.fontFamily};
    font-size: ${theme.typography.heading2_semiBold.fontSize};
    font-weight: ${theme.typography.heading2_semiBold.fontWeight};
    color: ${theme.colors.textMedium};
    margin-top: ${theme.spacing["5xl"]};
    margin-bottom: ${theme.spacing["5xl"]};
  `;

  const pageSubtitle = css`
    font-family: ${theme.typography.bodyMedium.fontFamily};
    font-size: ${theme.typography.bodyMedium.fontSize};
    font-weight: ${theme.typography.bodyMedium.fontWeight};
    color: ${theme.colors.textDark};
    margin-bottom: ${theme.spacing.xxxl};
  `;

  if (loading) return <div className="loaderPage"> <Loader /> </div>;
  if (error) return <div className="loaderPage"> <div>Error</div> </div>;

 const paragraphObj = referenceData?.paragraph?.[0] as any;
const children = paragraphObj?.children || [];
const markdownText = children?.[0]?.text || '';
  return (
    <>
      <div>
        <div css={pageTitle}>{referenceData?.title}</div>
     <ReactMarkdown css={pageSubtitle}>
        {markdownText}
    </ReactMarkdown>
        {referenceData?.rules?.sort((x, y) => x?.position - y?.position).map((ref, index) => (
          <div css={linkItem}>
            <a href={`#reference-card-${index}`}>
              {ref.title} - {ref.subtitle}
            </a>
            {ref.badge && <span>{ref.badge}</span>}
          </div>
        ))}

        <div css={referencesContainer}>
          {referenceData?.rules?.sort((x, y) => x?.position - y?.position).map((ref, index) => (
            <ReferenceCard
              key={index}
              id={`reference-card-${index}`}
              title={`${ref.title} - ${ref.subtitle}`}
              description={ref.paragraph}
              badge={ref.badge}
            />
          ))}
        </div>
      </div>
    </>
  );
}
